export default [
  { value: "none", label: "Selecionar" },
  { value: "00", label: "00 - Tributada integralmente" },
  { value: "20", label: "20 - Com redução da Base de Cálculo" },
  { value: "40", label: "40 - Isenta" },
  { value: "41", label: "41 - Não tributada" },
  {
    value: "60",
    label: "60 - ICMS cobrado anteriormente por substituição tributária"
  }
];



// WEBPACK FOOTER //
// ./src/core/enum/icms-values.enum.js